import React, { useEffect, useState } from "react";
import "./StarRating.scss";

type Props = {
    rating: number;
    setRating: (rating: number) => void;
};

const StarRating: React.FC<Props> = ({rating, setRating}) => {
    const [hover, setHover] = useState(rating);

    return (
      <div className="star-rating">
        {[...Array(5)].map((star, index) => {
          index += 1;
          return (
            <button
              type="button"
              key={index}
              className={index <= (hover || rating) ? "on" : "off"}
              onClick={() => setRating(index)}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(rating)}
            >
              <span className="star">&#9733;</span>
            </button>
          );
        })}
      </div>
    );
  };

  export default StarRating;